import styled, { css } from 'styled-components';
import {
  Box,
  Badge,
  Typography,
} from '@mui/material';

import DialogRoundedModal from '../../../../../../components/DialogRoundedModal';
import { ReactComponent as UserIcon } from '../../../../../../assets/icons/userIcon.svg';
import { ReactComponent as ContractIcon } from '../../../../../../assets/icons/contract-icon.svg';
import { ReactComponent as ChatIcon } from '../../../../../../assets/icons/broadcast-icon.svg';
import colors from '../../../../../../styles/colors';
import { sansSerifHeadlineFontStyles } from '../../../../../../styles/text';

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${({ $isSDRChat }) => ($isSDRChat ? '100%' : 'auto')};
  max-height: ${({ $isSDRChat }) => ($isSDRChat ? '100%' : '90vh')};
  min-height: ${({ $isSDRChat }) => ($isSDRChat ? 'auto' : '0')};
  overflow: hidden;
  color: ${colors.base.secondary2};
  flex: 1 1 auto;
`;

const TabHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: 1.5px solid ${colors.shades.secondary7};
  background-color: ${colors.shades.gamma5};

  .MuiTab-root {
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  background-color: ${colors.shades.secondary10};
`;

const TabContentContainer = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`;

const LeadInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.shades.secondary10};
  padding: 20px 50px 0px;
`;

const Title = styled.div`
  ${sansSerifHeadlineFontStyles}
  font-size: 22px;
  font-weight: 500;
  margin-left: 15px;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
  align-items: center;
  gap: 15px;
`;

const ContactInfoSection = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 10px;
`;

const PricingInstructionSection = styled.div`
  display: flex;
  padding: 10px;
  background-color: ${colors.shades.primary3};
`;

const PricingInstructionText = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  margin-left: 60px;
  color: ${colors.base.secondary2};
`;

const ModalContent = styled.div`
  padding: 12px 0 0 50px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-color: ${colors.shades.secondary10};
  height: 100%;
  min-height: 0;
`;

const SubTitle = styled.p`
  margin-left: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: ${colors.shades.secondary3};
`;

const StyledBadge = styled(Badge)`
  .MuiBadge-badge {
    background-color: ${colors.shades.danger3};
    color: ${colors.base.beta};
  }
`;

const TabLabel = styled.span`
  padding-right: 5px;
`;

const iconStyles = css`
  width: 18px;
  height: 18px;
  > path {
    fill: ${colors.shades.secondary7};
    stroke: ${colors.base.secondary2};
  }
`;

const StyledUserIcon = styled(UserIcon)`
  ${iconStyles}
`;

const StyledContractIcon = styled(ContractIcon)`
  ${iconStyles}
`;

const ActionButtonsSection = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1;
  background-color: ${colors.shades.secondary10};
  border-top: 1px solid ${colors.shades.secondary7};
  padding: 15px 20px;
`;

const StyledChatIcon = styled(ChatIcon)`
  ${iconStyles}
`;

const CoachLabel = styled.span`
  color: ${colors.shades.secondary3};
  font-weight: 600;
  font-size: 10px;
`;

const StyledLeadModalDialog = styled(DialogRoundedModal)`
  & .MuiDialog-paper {
    max-height: 90vh;
    overflow: visible;
    display: flex;
    flex-direction: column;
  }
  & .MuiDialogContent-root {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
  }
  & .MuiDialogContent-root > div {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }
`;

export {
  ContactInfoSection,
  PricingInstructionSection,
  PricingInstructionText,
  LeadInfoSection,
  Title,
  TitleSection,
  Container,
  TabHeaderRow,
  SubTitle,
  ModalContent,
  StyledBadge,
  TabLabel,
  StyledUserIcon,
  StyledContractIcon,
  StyledChatIcon,
  TopSection,
  TabContentContainer,
  ActionButtonsSection,
  StyledLeadModalDialog,
  CoachLabel,
};
